import Add from "../Imgs/Addd.png";
import Sub from "../Imgs/Sub.png";
import React, { useState } from "react";
import abi from "./abi.json";
import Web3 from "web3";
import detectEthereumProvider from "@metamask/detect-provider";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MerkleTree } from "merkletreejs";
import keccak256 from "keccak256";
import { white } from "./whitelist.js";

// import WalletConnectProvider from "@walletconnect/web3-provider";

import "./Home.css";
import "./MintBtn.css";

export default function Home() {
  const REACT_APP_CONTRACT_ADDRESS =
    "0xb47DbCC411eBFAa41E0FB074a4A886d1D09b914E";
  const SELECTEDNETWORK = "1";
  const SELECTEDNETWORKNAME = "Ethereum";
  let ct, web3;
  const [quantity, setQuantity] = useState(1);
  const [maxallowed, setMaxallowed] = useState(0);
  const [walletConnected, setWalletConnected] = useState(false);
  const [metamaskAddress, setMetamaskAddress] = useState("");
  const leaf = white.map((addr) => keccak256(addr));
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState(0);
  const merkleTree = new MerkleTree(leaf, keccak256, { sortPairs: true });

  function checkWhitelist(a) {
    const check = keccak256(a);
    const proof = merkleTree.getHexProof(check);
    const root = merkleTree.getRoot();

    return merkleTree.verify(proof, check, root);
  }

  function getProof(a) {
    const check = keccak256(a);
    return merkleTree.getHexProof(check);
  }

  async function checkNetwork() {
    if ((await web3.eth.net.getId()) == SELECTEDNETWORK) return true;
    toast.error('Enable "' + SELECTEDNETWORKNAME + '" network!');
    return false;
  }

  setTimeout(() => {
    initializeWeb3();
  }, 10);

  const initializeWeb3 = async () => {
    if (await detectEthereumProvider()) {
      window.web3 = new Web3(window.ethereum);
      web3 = window.web3;

      if (!checkNetwork()) return false;

      ct = new web3.eth.Contract(abi, REACT_APP_CONTRACT_ADDRESS);
      setStatus(await ct.methods.status().call());
      // setPrice(await ct.methods.PRICE().call());
      setTotal(await ct.methods.totalSupply().call());
      setMaxallowed(await ct.methods.MAX_PER_Address().call());
      return true;
    } else {
      toast.error(
        "Non-Ethereum browser detected. Please use a crypto wallet such as MetaMask!"
      );
      return false;
    }
  };
  const loadweb3 = async () => {
    if (!initializeWeb3()) return;

    let price = await ct.methods.PRICE().call();
    let p = price * quantity;
    if ((await web3.eth.getBalance(metamaskAddress)) < p) {
      toast.error("Insufficient Funds!");
      return;
    }

    let m = await ct.methods.numberMinted(metamaskAddress).call();

    if (m >= maxallowed) {
      toast.error("Already Minted Maximum Allowed!");
      return;
    }

    if (status == 1) {
      await toast.promise(
        ct.methods
          .whitelistMint(quantity, getProof(metamaskAddress))
          .send({ from: metamaskAddress, value: p }),
        {
          pending: "Mint in Progress!!",
          success: "Mint Success!!",
          error: "Mint Failed!!",
        }
      );
      return;
    } else if (status == 2) {
      await toast.promise(
        ct.methods.mint(quantity).send({ from: metamaskAddress, value: p }),
        {
          pending: "Mint in Progress!!",
          success: "Mint Success!!",
          error: "Mint Failed!!",
        }
      );
      return;
    }
    setTotal(await ct.methods.totalSupply().call());
  };

  const connectWallet = async () => {
    console.log(merkleTree.getRoot().toString("hex"));
    setWalletConnected(true);

    if (!initializeWeb3()) return false;
    await window.ethereum.enable();
    let m = await web3.eth.getAccounts();
    m = m[0];
    setMetamaskAddress(m);

    if (status == 0) {
      toast.error("Sale not Started!");
      return false;
    } else if (status == 1) {
      if (checkWhitelist(m)) {
        setWalletConnected(true);
      } else {
        toast.error("Not Whitelisted for this tier!");
        return false;
      }
    } else if (status == 2) {
      setWalletConnected(true);
    }
  };

  return (
    <div className="A AA">
      <div className="container-fluid  ">
        <div className="row hy justify-content-center">
          <div className="col-12  ">
            <br />
            <br />
            {walletConnected ? (
              <>
                <span className="quantityy">5555</span>
                <div className="quantityselector d-flex justify-content-center align-items-center ">
                  <button
                    className="count btn p-2"
                    onClick={() => setQuantity(quantity - 1)}
                    disabled={quantity <= 1}
                  >
                    <img src={Sub}></img>
                  </button>
                  <button onClick={loadweb3} className="btn Mint-button">
                    MINT {quantity}
                  </button>
                  <button
                    className="count btn p-2"
                    onClick={() => setQuantity(quantity + 1)}
                    disabled={quantity >= maxallowed}
                  >
                    <img src={Add}></img>
                  </button>
                </div>
              </>
            ) : (
              <button onClick={connectWallet} className=" btn Mint-button">
                CONNECT
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
